import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../../i18n.js';
import './language-switcher.scss';

const LANGUAGE_LABELS = {
  en: 'EN',
  ru: 'RU',
  ar: 'AR',
};

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <li className={`nav-item dropdown${isOpen ? ' show' : ''}`} ref={ref}>
      <button
        type="button"
        className="nav-link nav-icon-hover text-white border-0 bg-transparent language-switcher-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        {LANGUAGE_LABELS[i18n.language] || 'EN'}
      </button>
      <div className={`dropdown-menu dropdown-menu-end language-switcher-menu${isOpen ? ' show' : ''}`}>
        {SUPPORTED_LANGUAGES.map((lng) => (
          <button
            key={lng}
            type="button"
            className={`dropdown-item${i18n.language === lng ? ' active' : ''}`}
            onClick={() => handleSelect(lng)}
          >
            {LANGUAGE_LABELS[lng]}
          </button>
        ))}
      </div>
    </li>
  );
}

export default LanguageSwitcher;
